import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';
import { ListingVideo } from './types/Listing';

export type AddYoutubeVideoCall = (
  listingId: number,
  youtubeId: string,
) => Promise<{ data: ListingVideo[] }>;

export default (makeCall: MakeCall) => (
  listingId: number,
  youtubeUrl: string,
) =>
  makeCall<ListingVideo[]>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/youtube-video`,
    {
      data: { youtubeUrl },
    },
  );
